import React from "react";
import "./Contact_Us.css";
import { Form } from "react-bootstrap";
import Common_Btn from "../../common/common-btn/Common_Btn";

const Contact_Us = () => {
  return (
    <section id="contact_us" className="contact_section">
      <div className="contact_title_holder">
        <h2 className="contact_title">
          Let's Start a <br /> <span>Conversation!</span>
        </h2>
      </div>

      <div className="contact_banner_holder">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-12 order-lg-1 order-2">
            <div className="solo_img_holder">
              <img
                src="/Assets/images/contact-us/solo-img.png"
                className="solo_img"
              />
            </div>
          </div>

          <div className="col-lg-5 col-md-9 col-12 order-lg-2 order-1">
            <div className="contact_form_holder">
              <h2 className="contact">Contact Us</h2>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    className="contact_input"
                  />
                </Form.Group>

                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Enter your email"
                        className="contact_input"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Enter your number"
                        className="contact_input"
                      />
                    </Form.Group>
                  </div>
                </div>

                <Form.Group className="mb-4">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Type here..."
                    className="contact_textarea"
                  />
                </Form.Group>
              </Form>
            </div>

            <div className="submit_btn_holder">
              <Common_Btn btnText={"Submit"} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact_Us;
